import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CvType } from '@core/models/enums/cv-type.enum';
import { serverError } from '@core/models/messages';
import { CandidatService } from '@core/services/candidat-service/candidat.service';
import { LocalStorageService } from '@core/services/local-storage.service';
import { environment } from '@env/environment';
import { ExportService } from '@shared/services/export.service';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-cv-candidat-anonyme',
  templateUrl: './cv-candidat-anonyme.component.html',
  styleUrls: ['./cv-candidat-anonyme.component.css']
})
export class CvCandidatAnonymeComponent {
  cvTypeEnum = CvType;
  constructor(
    private spinner: NgxSpinnerService,
    private candidatService: CandidatService,
    private activatedRoute: ActivatedRoute,
    private toastrService: ToastrService,
    private router: Router,
    private localStorageService: LocalStorageService,
    private exportService: ExportService,
  ) {}
  connectedUser: any;
  endIndex: number = 5;
  idCandidat: any;
  selectedCandidate: any;
  totalItems: any;
  skillsCandidat: any;
  private unsubscribeAll: Subject<void> = new Subject();
  /* string */
  url: string = environment.baseUrl;

  ngOnInit(): void {
    window.scrollTo(0, 0);
    this.getIdCandidat();
    this.getSkills();
    this.connectedUser = this.localStorageService.getData('userConnected');
    console.log("this.connectedUser",this.connectedUser)
  }
  getIdCandidat() {
    this.activatedRoute.paramMap.subscribe({
      next: (params: any) => {
        this.idCandidat = params.params['idCandidat'];
        this.getCandidateById();
      },
    });
  }
  getCandidateById() {
    this.spinner.show();
    this.candidatService
      .getUserByIdd(this.idCandidat)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res: any) => {
          console.log('res', res);
          this.selectedCandidate = res.data[0];
          console.log('selected candidat', this.selectedCandidate);
          this.spinner.hide();
        },
        error: (err) => {
          console.log('err', err);
          this.spinner.hide();
        },
      });
  }

  getSkills() {
    this.candidatService
      .getSkillsCandidate(this.idCandidat)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          this.skillsCandidat =
            res.data.categoriesWithSubCategoriesAndSkills.slice(
              0,
              this.endIndex
            );
          console.log('skills candidat', this.skillsCandidat);
          this.totalItems = res.data.count;
        },
        error: (err) => {
          console.log('error get skills', err);
          this.toastrService.error(serverError);
        },
      });
  }
  exportToPDF() {
    const element = document.getElementById('kt_app_content');

    if (element) {
      this.spinner.show();
      html2canvas(element).then((canvas) => {
        const imgData = canvas.toDataURL('image/png');
        const pdf = new jsPDF();
        const imgProps = pdf.getImageProperties(imgData);
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
        pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
        pdf.save('export_Cv.pdf');
        this.spinner.hide();
      });
    } else {
      console.error('Element not found!');
    }
  }
  NavigateToUpdateCandidate() {
    this.router.navigate([
      '/accueil/candidats/profil-candidat/update',
      { idCandidat: this.idCandidat },
    ]);
  }

  /**
  * Download CV.
  *  
  * @param {string} cvType - The type of CV to export (e.g., WEGESTU or ESN).
  * @param {number} isAnonymous - Whether to export an anonymous version of the CV (1 : not anonymous, 2 : anonymous) .
  * @returns {void}
  */
    downloadCV(cvType : string, isAnonymous: number){   
      if(cvType === this.cvTypeEnum.WEGESTU){
        this.exportCVCandidate(isAnonymous, null)
      }else{
        this.exportCVCandidate(isAnonymous, this.selectedCandidate?.ESN_id)
      }
  }

 // @TOFIX: duplicated
/**
* Exports the CV of a candidate based on the specified type and company ID.
*
* @param {number} type - The type of CV to export (e.g., 1 for standard, 2 for anonymous)
* @param {number | null} idCompany - The ID of the company for which the CV is being exported.
*                          Use `null` if no specific company is associated.
*/
exportCVCandidate(type: number, idCompany : number | null) {

  this.spinner.show();
  const candidate = {
    ids: [this.idCandidat],
    last_name: this.selectedCandidate?.last_name,
    first_name: this.selectedCandidate?.first_name
  } 
  const exportMethod = idCompany !== null
    ? this.exportService.exportCVEsnCandidate(candidate, type, idCompany)
    : this.exportService.exportCVWegestuCandidate(candidate, type);

  exportMethod.subscribe({
    next: () => {
      this.spinner.hide();
    },
    error: () => {
      this.spinner.hide();
    },
  });
}

  /* unsubscribe from api */
  ngOnDestroy() {
    this.unsubscribeAll.next();
    this.unsubscribeAll.complete();
  }

}
